import { trackMixPanel } from '../services/mixpanel.service';

export const reportViewSpeedBump = (origin: string) => {
  trackMixPanel('View SpeedBump', {
    Origin: origin,
  });
};

export const reportActOnSpeedBump = (action: String) => {
  trackMixPanel('Act on Speed Bump', {
    Action: action,
  });
};
